/* eslint-disable @typescript-eslint/no-explicit-any */
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

// Optional Zone.js patches to improve performance
(window as any).__Zone_disable_requestAnimationFrame = true;
(window as any).__Zone_disable_on_property = true;
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove'];

// 🔄 Optional: Unregister existing service workers (use carefully in production)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister(); // Use only during debug or migration
    }
  });
}

// ✅ Bootstrap Angular app after DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .then(() => {
      // ✅ REMOVE SSR loader after Angular is bootstrapped
      const loader = document.querySelector('.root-mountroot');
      if (loader && loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }
    })
    .catch(err => console.error(err));
});

// ✅ Load Razorpay script
const script = document.createElement('script');
script.src = 'https://checkout.razorpay.com/v1/checkout.js';
script.defer = true;
document.body.appendChild(script);

// ❌ Handle JS chunk loading errors (e.g., stale service worker cache)
window.addEventListener('error', function (event) {
  const isChunkLoadError = event?.message?.includes('.js') && event?.message?.includes('failed');

  if (isChunkLoadError || (event?.filename?.includes('.js') && event?.message?.includes('Loading chunk'))) {
    console.warn('Chunk load error detected. Clearing caches and reloading...');
    caches.keys().then((names) => {
      return Promise.all(names.map(name => caches.delete(name)));
    }).finally(() => {
      window.location.reload();
    });
  }
});
